import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const HoldingModalStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      minWidth: "350px",
      width: "100%",
      height: "100%",
      bgcolor: "background.paper",
      padding: "0px 0px ",
      border: "none",
      overflowY: "auto",
      overflowX: "hidden",
      "::-webkit-scrollbar": {
        width: "10px",
      },
      "::-webkit-scrollbar-track": {
        "-webkit-border-radius": "10px",
        borderRadius: "10px",
      },
      "::-webkit-scrollbar-thumb": {
        "-webkit-border-radius": "10px",
        borderRadius: "10px",
        background: "rgb(200, 200, 200)",
      },
      [theme.breakpoints.up("md")]: {
        borderRadius: 15,
        width: "500px",
      },
    },
    mainPrices: {
      padding: "30px 15px",
      boxShadow: "3px 3px 10px 0 rgba(22, 32, 59, 0.1)",
      borderRadius: "12px",
    },
    headerContainer: {
      margin: "30px 15px",
      boxShadow: "3px 3px 10px 0 rgba(22, 32, 59, 0.1)",
      borderRadius: "12px",
    },
    header: {
      height: 90,
      backgroundColor: "#5470DE",
      borderRadius: "12px 12px 0px 0px",
    },
    titleContainer: {
      [theme.breakpoints.up("md")]: {
        paddingLeft: "10%",
      },
    },
    iconItem: {
      paddingRight: 10,
    },
    title: {
      color: "#fff",
      fontSize: "24px",
      "@media (max-width:400px)": {
        fontSize: "18px",
      },
    },
    priceContainer: {
      padding: "20px 0px",
    },
    mainPricesAvailable: {
      fontSize: "20px",
    },
    mainPricesValue: {
      fontSize: "40px",
      fontWeight: "bold",
    },
    button: {
      height: "85px",
    },
    depositButton: {
      display: "flex",
      justifyContent: "center",
      border: "1px solid #f5f5f5",
      height: "85px",
      borderRadius: "0px 0px 0px 12px",
    },
    withdrawButton: {
      display: "flex",
      justifyContent: "center",
      border: "1px solid #f5f5f5",
      height: "85px",
      borderRadius: "0px 0px 12px 0px",
    },
    buttonBorder: {
      display: "flex",
      justifyContent: "center",
      border: "1px solid lightgrey",
      height: "85px",
    },
    chartContainer: {
      padding: "0px 0px",
      marginBottom: "30px",
      [theme.breakpoints.up("md")]: {
        padding: "30px 0px",
      },
    },
    cardContainer: {
      height: "233px",
      padding: "25px 25px",
      boxShadow: "3px 3px 10px 0 rgba(22, 32, 59, 0.1)",
      borderRadius: "12px",
    },
    chartHeadingContainer: {
      marginBottom: "15px",
    },
    chartHeading: {
      fontSize: "26px",
      fontWeight: 700,
    },
    chartTokenContainer: {
      marginRight: "30px",
    },
    fontSize16: {
      fontSize: "16px",
    },
    fontSize14: {
      fontSize: "14px",
    },
    fontSize12: {
      fontSize: "12px",
    },
    chartTokenName: {
      fontSize: "14px",
    },
    recentTransactionHeaderContainer: {
      padding: "0px 30px",
    },
    recentTransactionHeader: {
      fontSize: "20px",
      fontWeight: 700,
    },
    transactionsContainer: {
      padding: "22px 10px 15px 5px",
      borderBottom: "1px solid lightgrey",
    },
    iconContainer: {
      border: "1px solid red",
    },
    transactionType: {
      height: "50px",
    },
    transactionButtonContainer: {
      width: "100%",
      height: "48px",
      marginBottom: "30px",
    },
    transactionButton: {
      width: "100%",
      height: "48px",
    },
    transactionButtonText: {
      fontSize: "16px",
      fontWeight: 600,
    },
    units: {
      fontSize: "16px",
      textAlign: "right",
    },
    price: {
      fontSize: "16px",
      textAlign: "right",
    },
    date: {
      fontSize: "12px",
    },
  }),
);
